import { createAsyncAction } from 'typesafe-actions';

export const getSessionAsyncAction = createAsyncAction(
    '@bs/GET_USER_SESSION_REQUEST [CMD]',
    '@bs/GET_USER_SESSION_SUCCESS [EVENT]',
    '@bs/GET_USER_SESSION_FAILURE [EVENT]'
)<void, any, Error|Response>();